import { RoleUI } from '../../types/interfaces';

import Api from './api';
import IRoleUIsApi from './interfaces/roleUIsApi';

class RoleUIsApi extends Api<RoleUI> implements IRoleUIsApi {
  constructor(abortController: AbortController) {
    super('roleui/', abortController);
  }
}

export default RoleUIsApi;
